// 热力图相关的信息

import {
  UPDATE_ACTIVE_INDUSTRY,
  UPDATE_HEAT_MAP_DATA,
  UPDATE_HEAT_MAP_COND
} from 'store/mutation-types'
import { fetchStockHeatMapDetail } from 'apis/stock'

const state = {
  sector: null,
  index: 'SP500',
  period: '1day',
  activeIndustry: null,
  activeIndustrySort: 'ASC',
  data: null
}

const mutations = {
  [UPDATE_HEAT_MAP_DATA](state, data) {
    state.data = data
  },
  [UPDATE_ACTIVE_INDUSTRY](state, industry) {
    state.activeIndustry = industry
  },
  [UPDATE_HEAT_MAP_COND](state, cond) {
    for (const p in cond) {
      state[p] = cond[p]
    }
  }
}

const getters = {
  heatMapSourceData(state) {
    if (state.sector) {
      const sector = state.data.sectors.find(d => {
        return d.name === state.sector
      })
      return {
        market: state.data.market,
        sectors: [sector]
      }
    }
    return state.data
  },
  isShowHeatMapIndustry(state) {
    return !!state.activeIndustry
  }
}

const actions = {
  getHeatMapDetail({ state, commit }) {
    const params = {
      index: state.index,
      period: state.period
    }
    return fetchStockHeatMapDetail(params).then(({ data: respData }) => {
      if (respData.ret === 0 && respData.items) {
        const data = respData.items[0]
        data.sectors = data.sectors.filter(d => d.name !== '全部')
        commit(UPDATE_HEAT_MAP_DATA, data)
      } else {
        return Promise.reject(respData)
      }
    })
  },
  selectHeatMapIndustry({ commit }, payload) {
    commit(UPDATE_ACTIVE_INDUSTRY, payload)
  },
  updateHeatMapCond({ commit }, payload) {
    commit(UPDATE_HEAT_MAP_COND, payload)
  }
}

export default {
  getters,
  state,
  mutations,
  actions
}
